export const getLeaseLedgerUrl = (leaseId: string | number) => {
  return `https://upandup.managebuilding.com/manager/app/rentroll/${leaseId}/financials/ledger?isByAccountView=0&isByDateView=1`
}

export const getLeaseSummaryUrl = (leaseId: string | number) => {
  return `https://upandup.managebuilding.com/manager/app/rentroll/${leaseId}/summary`
}

export const getLeasePaymentSettingsUrl = (leaseId: string | number) => {
  return `https://upandup.managebuilding.com/manager/app/rentroll/${leaseId}/financials/payment-settings`
}
